import angular from 'angular';
import {
  loaderService,
  ssDialogService,
  orgDataService,
  userService,
} from 'app/services';
import {
  alerts,
  importDocument,
  actionIcon
} from 'app/components/global';
import user from './user';
import editUserDialog from './dialog.editUserDialog';
import UserAdminController from './user-admin.controller';
import directive from './user-admin.directive';


export const userAdminRouteConfig = {
  template: require('./user-admin.html'),
  controller: 'UserAdminController',
  controllerAs: 'userAdminVM',
};

export default angular.module('app.components.admin.userAdmin', [
  alerts,
  actionIcon,
  editUserDialog,
  importDocument,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
  user
])
  .directive('userAdmin', directive)
  .controller('UserAdminController', UserAdminController)
  .name;

console.log('app.components.admin.userAdmin created');
